import { Component } from '@angular/core';
import { environment } from '@environments/environment';
import { PageBaseComponent } from './page-base.component';


@Component({
  selector: 'my-profile',
  styleUrls: ['./styles/styles-wrapper.css'],
  styles: [`
    h4 {
      text-align: center;
      font-size: 22px;
      font-weight: 400;
      margin-bottom: 16px;
    }
    .avatar {
      width: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-bottom: 30px;
    }
    .field {
      padding-top: 25px;
    }
  `],
  template: `

    <div class="wrapper-route">

      <!-- {{ currentUser | json }} -->

      <h4>Mi Perfil</h4>

      <div class="avatar">
        <kendo-avatar [border]="true" shape="circle" [imageSrc]="currentUser.image" width="128px" height="128px"></kendo-avatar>
        <span class="field">{{currentUser.name}}</span>                
        <span class="field"><span class="k-icon k-i-user"></span> {{currentUser.role}}</span>
        <span class="field"><span class="k-icon k-i-globe"></span> Sucursal: {{branchName}}</span>
      </div>  

      <kendo-floatingactionbutton
          icon="logout"
          text="Cerrar sesión"
          themeColor="primary"
          [offset]="{ x: '12px', y: '390px' }"
          [align]="{ horizontal: 'center', vertical: 'top' }"
          positionMode="absolute"
          (click)="logout()">
      </kendo-floatingactionbutton>

    </div>

  `
})
export class ProfileComponent extends PageBaseComponent {

  public branchName: string = environment.branchName;

}